




































/* General */
import Vue from 'vue'
import {
  ContentPlaceholders,
  ContentPlaceholdersText,
} from 'vue-content-placeholders'
import {
  IBreadcrumbDataFromListing,
  INavMenuItem,
} from '@/types/data-objects/global'

/* Mixins */

/* Components */

/* Helpers */
import BreadcrumbAssistant from '@/helpers/breadcrumb-assistant'

/* Data types */
import { EEntities } from '@/types'

/* API */

export default Vue.extend({
  name: 'ListingHeader',

  components: {
    ContentPlaceholders,
    ContentPlaceholdersText,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    entityId: {
      type: Number,
      default: null,
    },

    entityType: {
      type: String as () => EEntities,
      required: true,
    },

    isLoading: {
      type: Boolean,
      default: false,
    },

    isCustomFilterSubmitting: {
      type: Boolean,
      default: false,
    },

    isKanban: {
      type: Boolean,
      default: false,
    },

    showSampleRibbon: {
      type: Boolean,
      default: false,
    },

    defaultFilters: {
      type: Array as () => INavMenuItem[],
      default: (): INavMenuItem[] => [],
    },

    customFilters: {
      type: Array as () => INavMenuItem[],
      default: (): INavMenuItem[] => [],
    },

    currentFilter: {
      type: Object as () => INavMenuItem,
      required: true,
    },

    totalItemCount: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      EEntities,
    }
  },

  computed: {
    cachedBreadcrumbData(): IBreadcrumbDataFromListing {
      return BreadcrumbAssistant.lastVisitedBreadcrumbDataFromListing(
        this.$store,
      )
    },

    hasCachedBreadcrumbData(): boolean {
      if (!this.cachedBreadcrumbData) {
        return false
      }

      const breadcrumbMatchesEntityLanding =
        this.entityId !== null &&
        this.cachedBreadcrumbData.selectedEntityID === this.entityId

      const breadcrumbMatchesAllLanding =
        this.entityId === null &&
        this.cachedBreadcrumbData.selectedEntityID === null &&
        this.cachedBreadcrumbData.entityType === this.entityType

      return breadcrumbMatchesEntityLanding || breadcrumbMatchesAllLanding
    },

    internalCurrentFilter(): INavMenuItem {
      if (this.hasCachedBreadcrumbData) {
        // Will always be up-to-date since any current filter change will be watched
        // by breadcrumb-for-entity-landing and update the cache
        return this.cachedBreadcrumbData.currentFilter
      }
      return this.currentFilter
    },
  },

  methods: {
    handleDeleteCustomFilter(identifier: string) {
      this.$confirm(
        `<strong>This cannot be undone.</strong>
        <br>Are you sure you want to delete this?`,
        {
          dangerouslyUseHTMLString: true,
          center: true,
          confirmButtonText: 'Yes, Delete',
          confirmButtonClass: 'el-button--strawberry',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'el-button--text',
          type: 'warning',
          title: 'Delete this custom filter?',
        },
      ).then(() => {
        this.$emit(`delete-custom-filter`, identifier)
      })
    },
  },
})
